export interface Aabb {
  readonly minX: number;
  readonly minY: number;
  readonly maxX: number;
  readonly maxY: number;
}

export class SpatialHash<T> {
  private readonly buckets = new Map<string, Set<T>>();

  constructor(readonly cellSize: number) {
    if (!Number.isFinite(cellSize) || cellSize <= 0) {
      throw new Error("spatial hash cell size must be positive");
    }
  }

  get bucketCount(): number {
    return this.buckets.size;
  }

  clear(): void {
    this.buckets.clear();
  }

  insert(value: T, bounds: Aabb): void {
    this.forEachCell(bounds, (key) => {
      const bucket = this.buckets.get(key) ?? new Set<T>();
      bucket.add(value);
      this.buckets.set(key, bucket);
    });
  }

  query(bounds: Aabb): T[] {
    const found = new Set<T>();
    this.forEachCell(bounds, (key) => {
      for (const value of this.buckets.get(key) ?? []) found.add(value);
    });
    return [...found];
  }

  private forEachCell(bounds: Aabb, visit: (key: string) => void): void {
    const minimumX = Math.floor(bounds.minX / this.cellSize);
    const maximumX = Math.floor(bounds.maxX / this.cellSize);
    const minimumY = Math.floor(bounds.minY / this.cellSize);
    const maximumY = Math.floor(bounds.maxY / this.cellSize);
    for (let x = minimumX; x <= maximumX; x += 1) {
      for (let y = minimumY; y <= maximumY; y += 1) visit(`${x}:${y}`);
    }
  }
}
